export const BASE_URL = "/im_api";